package org.hs_soft.runmynesto.data.api_datasource.options.cash_register_config

import kotlinx.serialization.json.Json
import kotlinx.serialization.json.buildJsonObject
import kotlinx.serialization.json.put
import kotlinx.serialization.json.putJsonObject
import org.hs_soft.runmynesto.data.api_datasource.RequestManager
import org.hs_soft.runmynesto.domain.ApiClient
import org.hs_soft.runmynesto.domain.config.Errors
import org.hs_soft.runmynesto.domain.model.home.options.cash_register_config.devices.create_new_department.CreateNewDepartmentModel
import org.hs_soft.runmynesto.domain.model.home.options.cash_register_config.hardware.adyen_store.AdyenStoreModel
import org.hs_soft.runmynesto.domain.repository.network_datasource.options.cash_register_config.AydenStoresRepository
import org.hs_soft.runmynesto.domain.repository.network_datasource.options.cash_register_config.CreateNewDepartmentReopisotry
import org.hs_soft.runmynesto.domain.util.ApiUtils

class AydenStoresRepositoryImpl (
    private val apiClient: ApiClient,
    private val requestManager: RequestManager,
): AydenStoresRepository
{

    override suspend fun getAydenStores(): AdyenStoreModel {
        val abortController = requestManager.createController()

        val graphQLQuery = buildJsonObject {
            put(
                "query", """
                  query listAdyenStores {
                    cashAssist {
                      listAdyenStores {
                        ${ApiUtils.Field.id}
                         ${ApiUtils.Field.name}
                         ${ApiUtils.Field.__typename}
                      }
                       ${ApiUtils.Field.__typename}
                    }
                  }

                    
                """.trimIndent()
            )


            putJsonObject("variables") { }
        }

        val result = apiClient.requestResult(
            graphQLQuery = graphQLQuery,
            resource = ApiUtils.Cognito.API_URL,
            abortController = abortController,
        )

        return if (result != null) {
            Json.decodeFromString(result.decodeToString())
        } else {
            throw Exception(Errors.timeoutErr)
        }
    }


}
